import React from 'react'
import { Link} from 'gatsby'


const OtherOptionsMenu = ({isAllContent}) => {
    
    return (
        <>
        <p className="h5 font-weight-bold" >Other Options</p>
        { isAllContent === false &&
            <p className="h6">
                <Link className="animated" to="/allcontent">Browse all Research Content</Link>
            </p>
        }
        <p className="h6">
            <a className="animated" href="/dbtw-wpd/SimpleSearch.htm">Search for Legislative History</a>
        </p>
        <p className="h6">
            <a className="animated" href="/dbtw-wpd/SearchCatalogBasic.htm">Search the Library Catalog</a>
        </p>
        </>
    )
}

export default OtherOptionsMenu;